import { render, staticRenderFns } from "./CourseCardsFilters4.vue?vue&type=template&id=3da55fa2&"
import script from "./CourseCardsFilters4.vue?vue&type=script&lang=js&"
export * from "./CourseCardsFilters4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports